import { createFileRoute } from "@tanstack/react-router";
import { StudyGroupPage } from "@/features/all-study-groups/components/StudyGroupPage";
import { isSafeInternalPath } from "@/lib/navigation/userProfileNavigation";

type StudyGroupDetailSearch = {
  from?: string;
};

export const Route = createFileRoute("/all-study-groups/$study-group-id")({
  component: StudyGroupPage,
  validateSearch: (
    search: Record<string, unknown>,
  ): StudyGroupDetailSearch => ({
    from: isSafeInternalPath(search.from) ? search.from : undefined,
  }),
});
